// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary": "#003cff",
	"secondary": "#6f00fd",
	"tertiary": "#e1f6ff",
	"black": "#1d1929",
	"info": "#485dff",
	"success": "#06a947",
	"error": "#da2128",
	"warning": "#ff6d00",
	"background": "#f5f5f5",
	"barGraphColor": "#e8c1a0",
	"tabDefaultLabelColor": "#afadb2",
	"defaultLabelColor": "#a5a3a9",
	"defaultLineGraphLineColor": "#66c2a5",
	"defaultDatePickerBorderColor": "#a5a3a9",
	"quilityBgColor": "#46c3b2",
	"primary100": "#003cff",
	"primary200": "#e9e9ff",
	"primary300": "#c7c7ff",
	"secondary100": "#6f00fd",
	"secondary200": "#f0e5ff",
	"secondary300": "#d5c0ff",
	"tertiary100": "#e1f6ff",
	"tertiary200": "#b2e7ff",
	"neutral100": "#1d1929",
	"neutral200": "#a5a3a9",
	"neutral300": "#eaeae8",
	"neutral400": "#f9f9f9",
	"btnPrimaryColor": "#003cff",
	"btnPrimaryHoverColor": "rgba(0,60,255,.8)",
	"btnPrimaryTextColor": "#f9f9f9",
	"btnPrimaryTextHoverColor": "#f9f9f9",
	"btnPrimaryBorderColor": "rgba(0,0,0,0)",
	"btnSecondaryColor": "rgba(0,0,0,0)",
	"btnSecondaryHoverColor": "#003cff",
	"btnSecondaryTextColor": "#003cff",
	"btnSecondaryTextHoverColor": "#f9f9f9",
	"btnSecondaryBorderColor": "#003cff",
	"btnTertiaryColor": "rgba(0,0,0,0)",
	"btnTertiaryHoverColor": "rgba(0,0,0,0)",
	"btnTertiaryTextColor": "#003cff",
	"btnTertiaryTextHoverColor": "#003cff",
	"btnTertiaryBorderColor": "rgba(0,0,0,0)",
	"notificationUnreadBgColor": "rgba(255,226,204,.3019607843)",
	"accordionBgColor": "#f9f9f9",
	"accordionTextColor": "#1d1929",
	"accordionActiveTextColor": "#003cff",
	"primaryBorderColor": "#003cff",
	"primaryTextColor": "#fff",
	"primaryDisabledTextColor": "#003cff",
	"primaryDisabledBgColor": "#fff",
	"defaultBorderColor": "#dedede",
	"defaultTextColor": "#1d1929",
	"disabledTextColor": "#f9f9f9",
	"primaryBgColor": "#fff",
	"toggleActiveBgColor": "#003cff",
	"toggleInactiveBgColor": "#eaeae8",
	"tooltipBgColor": "#e8e8e8",
	"tooltipTextColor": "#1d1929",
	"tabTextColor": "#a5a3a9",
	"tabActiveTextColor": "#6f00fd",
	"disabledBgColor": "#f9f9f9"
};
export default ___CSS_LOADER_EXPORT___;
